// src/components/PfandOverview.js
import React from 'react';

export function determineChest(amount) {
  const a = Number(amount || 0);
  if (a >= 500) return 'diamond';
  if (a >= 200) return 'gold';
  if (a >=  50) return 'silver';
  return 'bronze';
}

/**
 * Props:
 *  - totals?: { total_collected, total_redeemed, available }
 *  - entries?: Array<any>  // Fallback
 *  - onRedeem?: (amount) => void
 */
export function PfandOverview({ totals, entries = [], onRedeem }) {
  let totalCollected = 0, totalRedeemed = 0, available = 0;

  if (totals && typeof totals === 'object') {
    totalCollected = Number(totals.total_collected || 0);
    totalRedeemed  = Number(totals.total_redeemed  || 0);
    available      = Number(
      totals.available != null ? totals.available : (totalCollected - totalRedeemed)
    );
  } else {
    // Fallback: aus (limitierten) entries summieren
    totalCollected = entries.reduce((acc, e) => acc + (parseFloat(e.amount) || 0), 0);
    totalRedeemed  = entries
      .filter(e => e.status === 'redeemed')
      .reduce((acc, e) => acc + (parseFloat(e.amount) || 0), 0);
    available      = Math.max(0, totalCollected - totalRedeemed);
  }

  const chest = determineChest(available);

  return (
    <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:'1rem',margin:'1.25rem 0'}}>
      <section style={{gridColumn:'1 / -1',background:'#fff',padding:'1rem',borderRadius:12,boxShadow:'0 1px 6px #0001'}}>
        <strong>🏴‍☠️ Gesammelter Pfandschatz (seit App-Start)</strong>
        <div style={{fontSize:'1.8rem',fontWeight:700,color:'#0b2c40'}}>
          {totalCollected.toFixed(2)} €
        </div>
        <div style={{color:'#888'}}>= verfügbar + bereits eingelöst</div>
      </section>

      <section style={{background:'#fff',padding:'1rem',borderRadius:12,boxShadow:'0 1px 6px #0001'}}>
        <strong>💰 Verfügbarer Pfand</strong>
        <p style={{fontSize:'1.5rem',color:'#2e7d32',margin:0}}>
          {available.toFixed(2)} €
        </p>
        <button
          onClick={() => onRedeem && available > 0 ? onRedeem(available) : null}
          disabled={available <= 0}
          style={{marginTop:'.5rem',padding:'.6rem 1rem',border:'none',borderRadius:8,
                  background: available > 0 ? '#1e88e5' : '#9e9e9e', color:'#fff',
                  cursor: available > 0 ? 'pointer' : 'not-allowed'}}
        >
          {available > 0 ? `Jetzt einlösen (${available.toFixed(2)} €)` : 'Nichts verfügbar'}
        </button>
        <div style={{fontSize:'.85rem',color:'#666',marginTop:'.25rem'}}>
          Truhen-Level: <b>{chest}</b>
        </div>
      </section>

      <section style={{background:'#fff',padding:'1rem',borderRadius:12,boxShadow:'0 1px 6px #0001'}}>
        <strong>✅ Bereits eingelöster Pfand</strong>
        <p style={{fontSize:'1.5rem',color:'#1565c0',margin:0}}>
          {totalRedeemed.toFixed(2)} €
        </p>
        <div style={{color:'#888'}}>Schon ausgezahlt</div>
      </section>
    </div>
  );
}
